import { useTranslation } from "react-i18next"
import { GridColDef } from "@mui/x-data-grid"
import { format } from "date-fns"

import Table from "@/components/table/Table"
import Pagination from "@/components/table/Pagination"
import { AIReportListItem } from "@/types/aiReport"
import { YEAR_TO_DAY_FORMAT } from "@/constants/regex"
import { useAiReportListQuery } from "@/hooks/api/useAiReportQuery"

import "./aiReportTable.scss"

type AIReportTableProps = {
  onRowClick: (idfReport: number) => void
}

export default function AIReportTable({ onRowClick }: AIReportTableProps) {
  const { t } = useTranslation()
  const { data: reportList, isLoading } = useAiReportListQuery()

  const columns: GridColDef<AIReportListItem>[] = [
    {
      field: "title",
      renderHeader: () => t("title"),
      flex: 1,
      minWidth: 300,
      sortable: false,
    },
    {
      field: "type",
      renderHeader: () => t("type"),
      width: 150,
      sortable: false,
      renderCell: (params) => params.value || "-",
    },
    {
      field: "status",
      renderHeader: () => t("status"),
      width: 150,
      sortable: false,
      renderCell: (params) => params.value || "-",
    },
    {
      field: "dateCreated",
      renderHeader: () => t("date"),
      width: 150,
      sortable: false,
      renderCell: (params) => format(new Date(params.value as string), YEAR_TO_DAY_FORMAT),
    },
  ]

  return (
    <div className="AIReportTableCont">
      <Table
        columns={columns}
        rows={reportList || []}
        getRowId={(row) => row.idfReport}
        onRowClick={(params) => onRowClick(params.row.idfReport)}
        disableRowSelectionOnClick
        disableColumnResize
        loading={isLoading}
        slots={{
          pagination: () => <Pagination />,
        }}
        autoHeight
      />
    </div>
  )
}
